import React, { KeyboardEvent } from 'react'
import { ControllerRenderProps } from 'react-hook-form'

import { TextInput } from '@app/lib/inputs/TextInput/TextInput'

export const AmountInput = ({
  inputProps,
  unit,
  className
}: {
  inputProps: ControllerRenderProps
  unit?: string
  className?: string
}) => {
  const handleDelete = (e: KeyboardEvent<HTMLInputElement>) => {
    const input = e.currentTarget
    const value = input.value

    const unitLength = unit ? unit.length + 1 : 0
    const curserAEndOfAmount =
      input.selectionStart !== null && input.selectionStart > value.length - unitLength

    if (curserAEndOfAmount) {
      e.preventDefault()
      const numericValue = value.replace(/[^0-9.-]/g, '')
      const newValue = numericValue.length > 0 ? numericValue.slice(0, -1) : ''
      inputProps.onChange(newValue)
    }
  }

  return (
    <TextInput
      {...inputProps}
      className={className}
      type={'text'}
      value={inputProps.value ? `${inputProps.value}${unit ? ` ${unit}` : ''}` : ''}
      onChange={(value) => {
        const numericValue = value?.replace(/[^0-9.-]/g, '')
        inputProps.onChange(numericValue)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Backspace') {
          handleDelete(e)
        }
      }}
    />
  )
}
